import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="relative overflow-hidden" style={{ backgroundColor: '#1a3a2a' }}>
      {/* Background large text */}
      <div className="absolute inset-0 flex items-end justify-center pointer-events-none select-none overflow-hidden">
        <span
          className="text-[12vw] md:text-[10vw] font-black leading-none opacity-[0.06] tracking-tighter whitespace-nowrap"
          style={{ color: '#e8d5b0', fontFamily: "var(--font-heading)", transform: 'translateY(15%)' }}
        >
          KUMANWU
        </span>
      </div>

      <div className="relative z-10 px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 max-w-7xl mx-auto">
          {/* Column 1: Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-book-read-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-bold text-white whitespace-nowrap" style={{ fontFamily: "var(--font-heading)" }}>
                酷漫屋
              </span>
            </Link>
            <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.55)' }}>
              酷漫屋是国内领先的免费漫画阅读平台，专注提供优质韩漫、国漫等各类漫画资源。下拉式阅读体验，高清画质，每日更新。
            </p>
          </div>

          {/* Column 2: Newsletter */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider mb-4" style={{ color: 'rgba(255,255,255,0.45)' }}>
              订阅更新
            </h4>
            <form
             
              action="http://lst56.com/project/kumanwu/subscribe"
              method="POST"
            >
              <div className="relative">
                <input
                  type="email"
                  name="email"
                  placeholder="输入邮箱获取更新通知"
                  className="w-full bg-transparent border-0 border-b text-sm py-2 pr-10 outline-none placeholder-gray-400 transition-colors duration-200"
                  style={{ color: 'rgba(255,255,255,0.8)', borderColor: 'rgba(255,255,255,0.2)' }}
                />
                <button
                  type="submit"
                  className="absolute right-0 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center cursor-pointer"
                  style={{ color: 'rgba(255,255,255,0.6)' }}
                >
                  <i className="ri-send-plane-line text-base"></i>
                </button>
              </div>
              <div className="contact-spam-field">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
            </form>
            <p className="text-xs mt-3" style={{ color: 'rgba(255,255,255,0.35)' }}>
              订阅即表示同意我们的{' '}
              <a href="/about" className="underline cursor-pointer hover:text-white transition-colors duration-200">
                隐私政策
              </a>
            </p>
          </div>

          {/* Column 3: Quick Links */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider mb-4" style={{ color: 'rgba(255,255,255,0.45)' }}>
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer" style={{ color: 'rgba(255,255,255,0.65)' }}>
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/hanman" className="text-sm hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer" style={{ color: 'rgba(255,255,255,0.65)' }}>
                  韩漫专区
                </Link>
              </li>
              <li>
                <Link to="/category/guoman" className="text-sm hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer" style={{ color: 'rgba(255,255,255,0.65)' }}>
                  国漫专区
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer" style={{ color: 'rgba(255,255,255,0.65)' }}>
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Categories */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider mb-4" style={{ color: 'rgba(255,255,255,0.45)' }}>
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    style={{ color: 'rgba(255,255,255,0.65)' }}
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 pt-6 border-t text-center" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
          <p className="text-xs" style={{ color: 'rgba(255,255,255,0.35)' }}>
            &copy; {new Date().getFullYear()} 酷漫屋 KUMANWU. 本站所有漫画均来自互联网，仅供学习交流使用。
          </p>
        </div>
      </div>
    </footer>
  );
}